<script setup lang="ts">

import master from "@layouts/master.vue";
import {Head, router, usePage} from "@inertiajs/vue3";
import LoginQr from "./sections/login-qr.vue";
import AppImage from "./sections/app-image.vue";
import StoreButtons from "./sections/store-buttons.vue";
import {onMounted, ref} from "vue";
import PrintContent from "./sections/print-content.vue";
import axios from "axios";

defineOptions({
    layout: master
});

let encryptionKey = ref(null);
let channel = ref(null);

let page = usePage()<any>

let props = defineProps({
    title: {
        type: Object,
        default: () => {
            return {
                test: 'test'
            }
        }
    },
    description: String,
});

onMounted(() => {
    //check if token is still valid
    if(localStorage.getItem('token')){
        checkToken();
    }
});

const checkToken = () => {
    axios.get(route('api.checkToken', {token: localStorage.getItem('token') ?? ''})).then((response) => {
        if(!response.data.tokenStillValid){
            localStorage.removeItem('token');
            localStorage.removeItem('refresh_token');
            router.reload();
        }
    });
}

</script>
<template>
    <Head>
        <title>
            {{ page.props.auth.user ? 'Print' : 'Login' }} | {{ page.props.app.name }}
        </title>
        <meta name="description" content="Login page">
    </Head>
    <div id="page-login">
        <div class="container">
            <div class="grid grid-cols-6 xl:grid-cols-6 gap-x-4 gap-y-10 items-center">
                <div class="col-span-6 xl:col-span-4 flex flex-col gap-16">
                    <login-qr
                        v-if="!page.props.auth.user"
                        @encryptionKey="encryptionKey = $event"
                        @channel="channel = $event"
                    ></login-qr>
                    <print-content
                        v-if="page.props.auth.user"
                    ></print-content>
                    <store-buttons></store-buttons>
                </div>
                <div
                    class="col-span-6 xl:col-span-2">
                    <app-image
                        :text="page.props.auth.user ? 'Book your meetingroom below' : undefined"
                        :encryptionKey="encryptionKey ? encryptionKey : null"
                        :channel="channel ? channel : null"
                    ></app-image>
                </div>
            </div>
        </div>
    </div>
</template>
